import React, { useEffect, useRef, useState } from "react";
import "./product.css";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { Carousel, Col, Row } from "antd";
import { useParams } from "react-router-dom";
import { getProduct, getProductReview } from "../../server/productServices";
import imageNotFound from "../../assets/images/image-not-available.png";
import ProductCreationModal from "./productCreationModal";
import { useAppContext } from "../../contexts/appContext";
import UserProductReview from "../../components/review/review";

const ProductDetails = () => {
  const { id } = useParams();
  const { startLoading, stopLoading, user } = useAppContext();
  const formRef = useRef();

  const [productDetail, setProductDetail] = useState();
  const [details, setDetails] = useState();
  const [productImages, setProductImages] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [productReview, setProductReview] = useState([]);

  var userRole = user?.role;
  var productAccess = user?.access?.product;

  const fetchProductDetails = async () => {
    startLoading();
    try {
      const res = await getProduct(id);
      const reviewRes = await getProductReview(id);
      setProductReview(reviewRes?.data || []);
      setProductDetail(res.data.product);
      setProductImages(res.data.images);
      setDetails({
        english: res.data.product.details.split(","),
        arabic: res.data.product.details_arabic.split(","),
      });
      stopLoading();
      setRefetch(false);
    } catch (error) {
      stopLoading();
      setRefetch(false);
    }
  };
  useEffect(() => {
    fetchProductDetails();
  }, [refetch]);
  const onClickEdit = () => {
    setShowUpdate(true);
  };
  return (
    <div>
      {showUpdate && (
        <ProductCreationModal
          showCreationModal={showUpdate}
          setShowCreationModal={setShowUpdate}
          formRef={formRef}
          update={productDetail.id}
          setUpdate={() => {}}
          setRefetch={setRefetch}
        />
      )}
      <StyledContentCard
        title={"Product Details"}
        showEdit={userRole === "Admin" || productAccess?.edit}
        onClickEdit={onClickEdit}
      >
        <Row>
          <Col span={12}>
            <div className="p-5">
              <div className="product-image-container">
                {productImages.length > 0 ? (
                  <Carousel arrows draggable>
                    {productImages.map((image, index) => (
                      <div key={index} className="carousel-item">
                        <img
                          className="product-image"
                          src={image.url}
                          alt={image.name || `Image ${index + 1}`}
                        />
                      </div>
                    ))}
                  </Carousel>
                ) : (
                  <div className="fallback-container">
                    <img
                      className="product-image"
                      src={imageNotFound}
                      alt="No Images Available"
                    />
                  </div>
                )}
              </div>
              <UserProductReview reviews={productReview} />
            </div>
          </Col>
          {productDetail && (
            <Col span={12}>
              <div className="p-4">
                {productDetail?.code && (
                  <p className="product-Code">{productDetail.code}</p>
                )}
                {productDetail?.name && (
                  <p className="product-title text-left">
                    {productDetail.name}
                  </p>
                )}
                {productDetail?.brand && (
                  <p>
                    Brand:{productDetail?.brand ? productDetail?.brand : "-"}
                  </p>
                )}
                {productDetail?.name_arabic && (
                  <p className="product-title" dir="rtl">
                    {productDetail.name_arabic}
                  </p>
                )}

                {productDetail?.brand_arabic && (
                  <p className="text-right" dir="rtl">
                    Brand:
                    {productDetail?.brand_arabic
                      ? productDetail?.brand_arabic
                      : "-"}
                  </p>
                )}
                <div className="flex flex-col gap-3 pt-3">
                  <div>
                    <div className="details-key">MRP</div>
                    <div className="product-price">
                      SR {productDetail?.mrp ? productDetail?.mrp : "-"}
                    </div>
                  </div>
                  <div>
                    <div className="details-key">Purchase Rate</div>
                    <div className="product-price">
                      SR{" "}
                      {productDetail?.purchase_rate
                        ? productDetail?.purchase_rate
                        : "-"}
                    </div>
                  </div>
                  <div>
                    <div className="details-key">VIP MRP</div>
                    <div className="product-price">
                      SR {productDetail?.vip_mrp ? productDetail?.vip_mrp : "-"}
                    </div>
                  </div>
                </div>
                {productDetail?.description && (
                  <div>
                    <p className="sub-title">Description:</p>
                    <p>{productDetail?.description}</p>
                  </div>
                )}
                {productDetail?.description_arabic && (
                  <div dir="rtl">
                    <p className="sub-title">Description:</p>
                    <p>{productDetail?.description_arabic}</p>
                  </div>
                )}
                {details?.english && (
                  <div className="details-table">
                    <p className="sub-title">Product Details</p>
                    <table>
                      <tbody>
                        {details?.english?.map((spec, index) => {
                          const [key, value] = spec
                            .split(":")
                            .map((item) => item.trim());
                          return (
                            <tr key={index}>
                              <td>{key}</td>
                              <td>{value}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {details?.arabic && (
                  <div className="details-table" dir="rtl">
                    <p className="sub-title">Product Details</p>
                    <table>
                      <tbody>
                        {details.arabic?.map((spec, index) => {
                          const [key, value] = spec
                            .split(":")
                            .map((item) => item.trim());
                          return (
                            <tr key={index}>
                              <td>{key}</td>
                              <td>{value}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Col>
          )}
        </Row>
      </StyledContentCard>
    </div>
  );
};

export default ProductDetails;
